// Configuración centralizada de colores para motivos/tipos de atención
// Este archivo asegura que cada motivo tenga el mismo color en todos los gráficos

// Paleta de colores predefinida
const colorPalette = [
  { background: 'rgba(54, 162, 235, 0.8)', border: 'rgba(54, 162, 235, 1)' },   // Azul
  { background: 'rgba(153, 102, 255, 0.8)', border: 'rgba(153, 102, 255, 1)' }, // Púrpura
  { background: 'rgba(75, 192, 192, 0.8)', border: 'rgba(75, 192, 192, 1)' },   // Cyan/Turquesa
  { background: 'rgba(34, 197, 94, 0.8)', border: 'rgba(34, 197, 94, 1)' },     // Verde
  { background: 'rgba(255, 159, 64, 0.8)', border: 'rgba(255, 159, 64, 1)' },   // Naranja
  { background: 'rgba(255, 99, 132, 0.8)', border: 'rgba(255, 99, 132, 1)' },   // Rojo/Rosa
  { background: 'rgba(255, 205, 86, 0.8)', border: 'rgba(255, 205, 86, 1)' },   // Amarillo
  { background: 'rgba(201, 203, 207, 0.8)', border: 'rgba(201, 203, 207, 1)' }, // Gris
];

// Mapa de colores específicos por motivo (para consistencia entre gráficos)
const motivoColorMap = {};

/**
 * Obtiene el color asignado a un motivo específico
 * Si el motivo no tiene color asignado, se le asigna uno de la paleta
 * @param {string} motivo - Nombre del motivo
 * @returns {object} - Objeto con colores background y border
 */
export const getColorForMotivo = (motivo) => {
  // Si el motivo ya tiene un color asignado, lo retornamos
  if (motivoColorMap[motivo]) {
    return motivoColorMap[motivo];
  }

  // Si no, le asignamos el siguiente color disponible de la paleta
  const numMotivosAsignados = Object.keys(motivoColorMap).length;
  const colorIndex = numMotivosAsignados % colorPalette.length;
  const color = colorPalette[colorIndex];
  
  motivoColorMap[motivo] = color;
  return color;
};

/**
 * Obtiene arrays de colores para una lista de motivos
 * @param {Array<string>} motivos - Array de nombres de motivos
 * @returns {object} - Objeto con arrays backgroundColors y borderColors
 */
export const getColorsForMotivos = (motivos) => {
  const backgroundColors = [];
  const borderColors = [];

  motivos.forEach(motivo => {
    const color = getColorForMotivo(motivo);
    backgroundColors.push(color.background);
    borderColors.push(color.border);
  });

  return { backgroundColors, borderColors };
};

/**
 * Resetea el mapa de colores de motivos
 * Útil cuando se cambia el período o se reinicia la sesión
 */
export const resetMotivoColors = () => {
  Object.keys(motivoColorMap).forEach(key => delete motivoColorMap[key]);
};

/**
 * Pre-asigna colores a una lista de motivos
 * Útil para mantener consistencia cuando se conocen todos los motivos por adelantado
 * @param {Array<string>} motivos - Array de nombres de motivos
 */
export const preassignMotivoColors = (motivos) => {
  motivos.forEach(motivo => {
    if (!motivoColorMap[motivo]) {
      getColorForMotivo(motivo);
    }
  });
};

export default {
  getColorForMotivo,
  getColorsForMotivos,
  resetMotivoColors,
  preassignMotivoColors,
};
